import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaHydropowerApi = createApi({
    reducerPath: "core/measurement/hydropower",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementHydropowerList"],
    endpoints: (builder) =>({
        measurementHydropowerFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementHydropowerList'],
            query: (query = '') => ({
                url: "core/measurement/hydropower" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementHydropowerCreate: builder.mutation({
            invalidatesTags: ['measurementHydropowerList'],
            query: (data)=>({url: "core/measurement/hydropower", method: "POST", data})
        }),
        measurementHydropowerUpdate: builder.mutation({
            invalidatesTags: ['measurementHydropowerList'],
            query: (data)=>({url: "/core/measurement/hydropower/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        measurementHydropowerDelete: builder.mutation({
            invalidatesTags: ['measurementHydropowerList'],
            query: (id)=>({url: "/core/measurement/hydropower/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementHydropowerFindAllQuery, useMeasurementHydropowerCreateMutation, useMeasurementHydropowerUpdateMutation, useMeasurementHydropowerDeleteMutation } = meaHydropowerApi;
export {meaHydropowerApi};
